import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DocumentReviewClauses from "./DocumentReviewClauses/DocumentReviewClauses";
import DocumentReviewListing from "./DocumentReviewListing/DocumentReviewListing";
import { EVENT_NAMES } from "../../../constants/events";
import { amplitudeLogEvent } from "../../../utils/amplitudeUtils";

// Internal imports
import { clauseTypes } from "../../../constants/metalens";
import DocumentReviewSpotlights from "./DocumentReviewClauses/DocumentReviewSpotlights";

// Action imports
import { removeSpotlightBlockEntities } from "../../../actions/MetalensActions/metalensActions";

const DocumentReviewSection = ({
  match: { params },
  removeSpotlightBlockEntitiesAction,
}) => {
  const [listingActive, setListingActive] = useState(true);
  const [clauseType, setClauseType] = useState(clauseTypes[0]);

  const _activateClauses = (newClauseType, insightsCount = 0) => {
    setClauseType(newClauseType);
    setListingActive(false);
    // Amplitude
    amplitudeLogEvent(EVENT_NAMES.CLAUSE_ANALYSIS_REVIEW_TYPE_SELECTED, {
      Type: newClauseType.title,
      InsightsCount: insightsCount,
    });
  };

  const _goBackToListing = () => {
    setListingActive(true);
    // remove spotlight
    removeSpotlightBlockEntitiesAction();
  };

  let sharingHash = null;
  const { sharingHash: newSharingHash } = params;
  if (newSharingHash) {
    sharingHash = newSharingHash;
  }

  return (
    <div className="documentreviewsection">
      {/* {listingActive ? ( */}
      <DocumentReviewListing
        active={listingActive}
        activateClauses={_activateClauses}
        sharingHash={sharingHash}
      />
      {/* ) : ( */}
      <DocumentReviewClauses
        active={!listingActive && clauseType.department !== "Spotlight"}
        goBack={_goBackToListing}
        clauseType={clauseType}
        sharingHash={sharingHash}
      />
      {/* )} */}
      {/* spotlight */}
      <DocumentReviewSpotlights
        active={!listingActive && clauseType.department === "Spotlight"}
        goBack={_goBackToListing}
        clauseType={clauseType}
        sharingHash={sharingHash}
      />
    </div>
  );
};

const mapDispatchToProps = {
  removeSpotlightBlockEntitiesAction: removeSpotlightBlockEntities,
};

export default withRouter(
  connect(null, mapDispatchToProps)(DocumentReviewSection),
);
